export enum FastagStatus {
  Active,
  LowBalance,
  Blacklisted,
  Closed,
}

export const StatusMapping = {
  ACTIVE: FastagStatus.Active,
  INACTIVE: FastagStatus.Active,
  BLACKLIST: FastagStatus.Blacklisted,
};

export const AMOUNT_HINT: number[] = [500, 1000, 2500, 5000];
export const MIN_DEFAULT_AMT = 100;
export const MAX_DEFAULT_AMT = 5000;
export const SHOW_BBPS_LOGO = true;
export const BBPS_LOGO =
  'https://parkplus-bkt-img.parkplus.io/production/fastag/public/bbpsimg_20250124201730079621_44d2c1f1-0fdf-455b-84d3-e48e4883a3b1.png';

export enum KycTikcetStatus {
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS',
}

export enum BANKS {
  IDFC = 'IDFC',
}

export function isValidPan(input) {
  let regex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  return regex.test(input);
}

export const FALLBACK_VEHICLE_IMAGE = "https://parkplus-bkt-img.parkplus.io/production/social-community/public/pulseOfIndiaBanner_20250603165736119594_9d9c9240-9d58-4d70-ba17-982422a2a26a.webp";
